import {HttpErrorResponse, HttpEvent, HttpInterceptorFn} from '@angular/common/http';
import {catchError, Observable, throwError} from "rxjs";
import {inject} from "@angular/core";
import {AuthService} from "@core/services/auth.service";
import {Router} from "@angular/router";
import {RedeService} from "@core/services/rede.service";

export const authInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<any>> => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const redeService = inject(RedeService);
    let authReq = req;
    const token = authService.getIdToken();
    const passeRede = token ? null : redeService.getPasse();
    if (token) {
        authReq = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`)
        });
    } else if (passeRede) {
        // visitante que passou pela prova de rede (ver RedeService)
        authReq = req.clone({
            headers: req.headers.set(RedeService.CABECALHO, passeRede)
        });
    }

    return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
            // Só redireciona ao login se o usuário tinha um token (sessão expirada).
            // Se não tinha token, é acesso anônimo — deixa o erro ser tratado pelo componente.
            if (error.status === 401 && authService.getIdToken()) {
                authService.logout();
                router.navigate(['/auth/login']).then(() => console.info('[AuthInterceptor] 401 HTTP STATUS detected - redirect to login'));
            } else if (error.status === 401 && error.error?.codigo === 'FORA_DA_REDE') {
                // visitante fora da rede da ARTESP (ou passe vencido): só com login
                redeService.limpar();
                router.navigate(['/auth/login']).then(() => console.info('[AuthInterceptor] fora da rede - redirect to login'));
            }
            return throwError(() => error);
        })
    );
};
